"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Slide = _interopRequireDefault(require("@mui/material/Slide"));

var _Icon = _interopRequireDefault(require("./Icon/Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    avatar: {
      backgroundColor: palette.orange.main,
      width: 46,
      height: 46,
      marginRight: spacing(2)
    },
    icon: {
      color: 'white'
    },
    root: {
      width: 420,
      marginLeft: spacing(2),
      marginRight: spacing(2)
    }
  };
});

var Transition = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      slideProps = (0, _objectWithoutProperties2["default"])(_ref2, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(_Slide["default"], (0, _extends2["default"])({
    direction: "up",
    ref: ref
  }, slideProps), children);
});

var ModalMessage = function ModalMessage(_ref3) {
  var isOpen = _ref3.isOpen,
      children = _ref3.children,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? 'exclamation-circle' : _ref3$icon,
      title = _ref3.title,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 400 : _ref3$width,
      _ref3$backdropStyles = _ref3.backdropStyles,
      backdropStyles = _ref3$backdropStyles === void 0 ? {} : _ref3$backdropStyles,
      _ref3$customClasses = _ref3.customClasses,
      customClasses = _ref3$customClasses === void 0 ? {} : _ref3$customClasses,
      DialogProps = _ref3.DialogProps,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'info' : _ref3$variant,
      paperStyles = _ref3.paperStyles;
  var classes = useStyles();

  var localBackdropStyles = _objectSpread({
    top: 80,
    left: 'initial',
    background: 'white',
    opacity: 0.8,
    width: width
  }, backdropStyles);

  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
    TransitionComponent: Transition,
    style: {
      width: width,
      left: 'initial'
    },
    BackdropProps: {
      style: localBackdropStyles
    },
    PaperProps: {
      elevation: 1,
      square: false,
      classes: {
        root: (0, _classnames["default"])(classes.root, classes["".concat(variant, "Root")], customClasses.root)
      },
      style: paperStyles
    },
    disablePortal: true,
    open: isOpen
  }, DialogProps), /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, icon && /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    className: (0, _classnames["default"])(classes.avatar, classes["".concat(variant, "Avatar")], customClasses.avatar)
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: (0, _classnames["default"])(classes.icon, customClasses.icon),
    icon: icon
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    "data-testid": "modalConfirmationTitle",
    className: (0, _classnames["default"])('H3-Dark', customClasses.title)
  }, title))), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, children));
};

var _default = ModalMessage;
exports["default"] = _default;